// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminDashboard_wrapper__h0xCD","title":"AdminDashboard_title__1BU2P","spinner":"AdminDashboard_spinner__VRoec"};